import * as ResultsUtils from '../utils/results';
import MathUtils from '../utils/math';
import LowPass from '../filter/low-pass';

var _getOpAmpNonIdealities = function (stageFp, gain, timeAxis) {
  var stepResponseSetup = LowPass.setupFirstOrderStepResponse(stageFp, gain);
  var impulseArrayFirstElement = LowPass.getImpulseArrayFirstElement(gain);
  var result = [impulseArrayFirstElement];
  var firstPoint = ResultsUtils.computeFirstOrderStepResponseIdeal(timeAxis[0], stepResponseSetup);
  //starting the loop with second point
  for (var t = 1; t < timeAxis.length; t++) {
    var secondPoint = ResultsUtils.computeFirstOrderStepResponseIdeal(timeAxis[t], stepResponseSetup);
    result.push(secondPoint - firstPoint);
    firstPoint = secondPoint;
  }

  return result;
};

var _getStageFp = function (circuit, k) {
  var gbw = circuit.opAmp.gbw;
  var result = gbw / k;
  return result;
};

export function getActualStepResponse(idealStep, circuit, timeAxis, k) {
  var stageFp = _getStageFp(circuit, k);
  var opAmpNonIdealities = _getOpAmpNonIdealities(stageFp, 1, timeAxis);
  var result = MathUtils.convolve(idealStep, opAmpNonIdealities);
  return result;
}
